export class AdditionalField {
  code?: string;
  name?: string;
  translatedName?: string;
  value?: string;
  defaultValue?: string;
  fieldType?: string;
  scope?: string;
  isMandatory?: boolean;
  isUnique?: boolean;
  additionalFieldListValues?: Array<string>;
  additionalFieldListTranslatedValues?: Array<string>;
}

export enum FieldType {
  TXT,
  INT,
  FLOAT,
  DTO,
  DT,
  TMO,
  BOOL,
  CBO,
  MEMO,
}
